var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(-1573 -8368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 49,
    height: 49,
    transform: "translate(1573 8368)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_facebook_2",
    d: "M7.246,2A5.246,5.246,0,0,0,2,7.246v15.51A5.245,5.245,0,0,0,7.246,28h15.51A5.244,5.244,0,0,0,28,22.756V7.232A5.312,5.312,0,0,0,22.756,2Zm0,1.128h15.51a4.173,4.173,0,0,1,4.116,4.13v15.5a4.093,4.093,0,0,1-4.116,4.116H19.484V17.228h2.734l.751-4.512H19.484V11.588c0-.31.031-.335.142-.406a2.181,2.181,0,0,1,.986-.158h2.256V7.229L22.477,7.1a13.073,13.073,0,0,0-3.557-.592A4.25,4.25,0,0,0,15.355,8a5.816,5.816,0,0,0-.947,3.591v1.128H12.716v4.512h1.692v9.644H7.246a4.094,4.094,0,0,1-4.118-4.116V7.246A4.1,4.1,0,0,1,7.246,3.128ZM18.92,7.64a10.626,10.626,0,0,1,2.82.436V9.9H20.612a2.851,2.851,0,0,0-1.6.336,1.594,1.594,0,0,0-.661,1.356v2.256h3.283L21.262,16.1H18.356V26.872h-2.82V16.1H13.844V13.844h1.692V11.588a4.838,4.838,0,0,1,.717-2.908A3.029,3.029,0,0,1,18.92,7.64Z",
    transform: "translate(1583 8378)",
    fill: "#222"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFacebook);
export default __webpack_public_path__ + "static/media/yellowFacebook.12f7e48ac283d0b556abd45a65f99ae3.svg";
export { ForwardRef as ReactComponent };